module.exports = [
  { key: '01', value: 'No objeto de impuesto.' },
  { key: '02', value: 'Sí objeto de impuesto.' },
  { key: '03', value: 'Sí objeto del impuesto y no obligado al desglose.' },
  { key: '04', value: 'Sí objeto del impuesto y no causa impuesto.' },
];
